// Written by claude-scripts/import-demo-client-photos.sh from the developer's download of the Pexels
// collection it names. Run the script again to change the set. Only the presents tags are edited by hand,
// from looking at each photo, and a re-import keeps each number's tag.
import { IDemoClientPhoto } from './IDemoClientPhoto';

/** The invented caseload's photos, as paths the app serves, each a few kilobytes, and whether each shows a woman or a man where that is clear. */
export const DEMO_CLIENT_PHOTOS: IDemoClientPhoto[] = [
    { file: '/assets/images/demo-clients/01.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/02.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/03.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/04.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/05.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/06.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/07.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/08.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/09.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/10.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/11.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/12.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/13.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/14.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/15.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/16.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/17.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/18.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/19.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/20.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/21.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/22.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/23.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/24.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/25.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/26.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/27.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/28.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/29.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/30.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/31.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/32.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/33.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/34.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/35.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/36.jpg', presents: 'man' },
    { file: '/assets/images/demo-clients/37.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/38.jpg' },
    { file: '/assets/images/demo-clients/39.jpg', presents: 'woman' },
    { file: '/assets/images/demo-clients/40.jpg', presents: 'woman' }
];
